// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ColoringEnum, DirectionArrowEnum } from './Level1CalculatorUtils';
export class Level1CalculatorViewModelHelper {
    static getWMColor(coloring, forceNeutral = null) {
        if (coloring === ColoringEnum.Positive) {
            return 'green';
        }
        else if (coloring === ColoringEnum.Negative) {
            return 'red';
        }
        else {
            return forceNeutral || 'white';
        }
    }
    static getDesktopColor(coloring) {
        if (coloring === ColoringEnum.Positive) {
            return 'positive-value';
        }
        else if (coloring === ColoringEnum.Negative) {
            return 'negative-value';
        }
        else {
            return 'gray';
        }
    }
    static getArrow(direction) {
        if (direction === DirectionArrowEnum.Up) {
            return '↑';
        }
        else if (direction === DirectionArrowEnum.Down) {
            return '↓';
        }
        else {
            return '';
        }
    }
}
